export type Camera = {
  deviceId: string;
  facingMode?: string | string[];
  frameRate?: { min: number; max: number };
};

export const startCamera = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: true,
    });

    stream.getVideoTracks().forEach((track) => track.stop());
  } catch (error) {
    console.error('Error iniciando la cámara:', error);
  }
};

export const loadCameras = async (): Promise<Camera[]> => {
  const nCameras: Camera[] = [];

  if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
    throw new Error('La API MediaDevices no está soportada en este navegador');
  }

  const devices = await navigator.mediaDevices.enumerateDevices();
  const cameras = devices.filter((device) => device.kind === 'videoinput');

  for (const camera of cameras) {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { deviceId: camera.deviceId },
      });
      const track = stream.getVideoTracks()[0];
      let capabilitie = []
      let cameraData: Camera = { deviceId: camera.deviceId };

      if (track.getCapabilities) {
        const capabilities = track.getCapabilities();
        capabilitie.push(capabilities)
        cameraData.facingMode = capabilities.facingMode || 'user';
      } else if (track.getSettings) {
        const settings = track.getSettings();
        cameraData.facingMode = settings.facingMode || 'user';
      }

      nCameras.push(cameraData);
      track.stop();
    } catch (error) {
      console.warn('Error al obtener cámara:', camera.label, error);
    }
  }

  if (!nCameras.length) {
    throw new Error('No se encontraron cámaras disponibles');
  }

  return nCameras;
};

